module.exports = __webpack_public_path__ + "img/frame (280).acb2cfb2.jpg";